import { render } from "./MinimizeIcon.vue?vue&type=template&id=4a215d5a"
import script from "./MinimizeIcon.vue?vue&type=script&lang=js"
export * from "./MinimizeIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__